import type { DeficiencySeverity, DeficiencyStatus } from "../../services/deficiencies";

const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL || "http://localhost:4200";

export const CASE_BRIEF_FEATURE_KEY = "case-brief";

export function chapterUrl(projectId: number, chapterId: number) {
  return `${FRONTEND_URL}/projects/${projectId}?tab=document&chapterId=${chapterId}`;
}

export function caseBriefUrl(caseBriefId: number) {
  return `${FRONTEND_URL}/create-project?caseBriefId=${caseBriefId}`;
}

export const TYPE_LABELS: Record<string, string> = {
  inconsistency: "Inconsistency",
  redundancy: "Redundancy",
  repetition: "Repetition",
  tone_of_voice: "Tone of Voice",
  translation_quality: "Translation Quality",
  low_confidence_claim: "Low Confidence Claim",
  missing_citation: "Missing Citation",
  hallucination: "Hallucination",
  other: "Other"
};

export const SEVERITY_STYLES: Record<DeficiencySeverity, string> = {
  critical: "bg-red-100 text-red-800 border-red-200",
  major: "bg-orange-100 text-orange-800 border-orange-200",
  minor: "bg-yellow-100 text-yellow-800 border-yellow-200"
};

export const SEVERITY_ORDER: Record<DeficiencySeverity, number> = { critical: 0, major: 1, minor: 2 };
export const SEVERITIES: DeficiencySeverity[] = ["critical", "major", "minor"];

export const STATUS_LABELS: Record<DeficiencyStatus, string> = {
  open: "Open",
  in_review: "In review",
  cured: "Cured",
  dismissed: "Dismissed",
  stale: "Stale"
};

export const STATUS_STYLES: Record<DeficiencyStatus, string> = {
  open: "bg-blue-50 text-blue-700 border-blue-200",
  in_review: "bg-purple-50 text-purple-700 border-purple-200",
  cured: "bg-green-50 text-green-700 border-green-200",
  dismissed: "bg-gray-100 text-gray-500 border-gray-200",
  stale: "bg-gray-100 text-gray-400 border-gray-200"
};
